import request from '../../../utils/request';

export interface ISnPublisherAlias {
  id: number;
  alias_name: string;
  canonical_name: string;
  created_at: string;
}

export interface ISnPublisherAliasListResponse {
  data: ISnPublisherAlias[];
  count: number;
  page: number;
  limit: number;
}

const BASE = '/cmdb-sn-publisher-aliases';

class SnPublisherAliasService {
  async list(page: number, limit: number): Promise<ISnPublisherAliasListResponse> {
    const res = await request({ url: `${BASE}?page=${page}&limit=${limit}`, method: 'GET' });
    return res.data.body.data;
  }

  async create(alias_name: string, canonical_name: string): Promise<void> {
    await request({ url: BASE, method: 'POST', data: { alias_name, canonical_name } });
  }

  async update(id: number, alias_name: string, canonical_name: string): Promise<void> {
    await request({ url: `${BASE}/${id}`, method: 'PUT', data: { alias_name, canonical_name } });
  }

  async remove(id: number): Promise<void> {
    await request({ url: `${BASE}/${id}`, method: 'DELETE' });
  }
}

export default new SnPublisherAliasService();
